<script>
import { Link, useLocation } from "svelte-navigator";

export let sections;

const location = useLocation();
</script>

<div class="nav col">
  {#each sections.filter(v => v.icon) as section}
    <Link to={section.path}>
      <div class="tile-row row vcenter" class:active={$location.pathname === `/${section.path}`}>
        <div class="tile centercenter">
          {#if section.icon[0] === '/'}
            <!-- svelte-ignore a11y-missing-attribute -->
            <img src={section.icon} class="image-icon" />
          {:else}
            <span class="material-icons">{section.icon}</span>
          {/if}
        </div>
        <div class="text">{section.sectionTitle}</div>
      </div>
    </Link>
  {/each}
</div>

<style lang="scss">
@import '../util';

$hoverWidth: 250px;

.nav {
  position: fixed;
  z-index: 10;
  left: 0;
  top: 80px;
  bottom: 0px;
  width: 80px;
  background-color: var(--primary);
  padding-top: 12px;
  transition: ease-out 250ms;
  overflow: hidden;
  color: var(--text-primary);
  user-select: none;
  
  @include mobile {
    display: none;
  }
}

.nav:hover {
  width: $hoverWidth;
}

.tile-row {
  cursor: pointer;
  padding-right: 16px;

  // Fix the width to prevent word-wrapping text movement during animated width updates
  width: $hoverWidth;
}

.tile-row:hover {
  background-color: var(--secondary);
  color: var(--text-primary);
}

.tile-row.active {
  background-color: var(--secondary);
  color: var(--text-primary);
}

.tile-row.active .tile {
  color: var(--text-secondary);
}

.tile-row:hover .image-icon {
  // Computed via: https://codepen.io/sosuke/pen/Pjoqqp
  filter: brightness(0) saturate(100%) invert(14%) sepia(68%) saturate(0%) hue-rotate(184deg) brightness(96%) contrast(86%);
}

.tile-row.active .image-icon {
  filter: brightness(0) saturate(100%) invert(14%) sepia(68%) saturate(0%) hue-rotate(184deg) brightness(96%) contrast(86%);
}

.tile {
  height: 48px;
  width: 80px;
  flex-shrink: 0;
  color: var(--text-primary);
}

.tile-row:hover .tile {
  color: var(--text-secondary);
}

.text {
  font-size: 16px;
  font-weight: normal;
}
</style>